export default "/images/vendor/flag-icon-css/flags/1x1/st.svg?342a4d3c791c89ec3103cbfbc44496c0";